<!-- prettier-ignore -->

<div class="add-custom-location-container">

    <div class="add-custom-location-container__header">
        <span>{{'Añadir punto de inicio/final' | translate}}</span>
        <ion-icon (click)="closeModal()" style="padding: 10px; font-size: 30px; color: #fff; cursor: pointer" name="close"></ion-icon>
    </div>

    <div class="add-custom-location-container__body">
        <div class="add-custom-location-container__body__day-container">
            <!-- <span>{{'Selecciona día' | translate}}</span> -->
            <div (click)="goLeft()" class="add-custom-location-container__body__day-container__navigation-buttons" [ngClass]="{'show': checkWidth()}"> < </div>
            <div #daysContainer class="add-custom-location-container__body__day-container__buttons">
                @if(arrayDays?.length > 1){
                    <button style="background: #000;" (click)="selectDay('all')" [ngClass]="{'selected': !selectedDay() || selectedDay() === 'all'}">
                        {{'Todos' | translate}}
                    </button>
                    @for(day of arrayDays; track $index) {
                        <button [ngStyle]="{'background': arrayColors[$index]}" (click)="selectDay(day)" [ngClass]="{'selected': selectedDay() === day}">
                            {{'Día' | translate}} {{ day }}
                        </button>
                    }
                }

            </div>
            <div (click)="goRight()" class="add-custom-location-container__body__day-container__navigation-buttons" [ngClass]="{'show': checkWidth()}"> > </div>
        </div>
        <div class="add-custom-location-container__body__location-container">
            <cicerone-google-maps-places (locationForm)="getLocation($event)"></cicerone-google-maps-places>
        </div>

    </div>

    <div class="add-custom-location-container__footer">
        <!-- <button (click)="closeModal()" class="cancel">{{'Cancelar' | translate}}</button> -->
        <button (click)="confirm('start')">{{'Añadir punto inicio' | translate}}</button>
        <button (click)="confirm('end')">{{'Añadir punto final' | translate}}</button>

    </div>

</div>